import React from "react";
import "./about.scss";

import carmella from "../../assets/me/webp/myprofile.png";

const About: React.FC = () => {
  return (
    <div className="about-container" id="about">
      <section className="about-intro">
        <div className="about-text">
          <h2 className="about-title">About Me</h2>

          <p>
            Hi, I’m <span className="purple-text">Carmella Setiabudi</span>, a Computer Science student at 
            York University with experience across software development, automation, and ML research. 
            I’ve completed software engineering internships at <span className="purple-text">League</span>,{" "}
            <span className="purple-text">BMO Capital Markets</span>,{" "}
            <span className="purple-text">TD Securities</span>, and{" "}
            <span className="purple-text">State Street</span>.
          </p>

          <p>
            I’m focused on <span className="purple-text">Backend, Full-Stack, and Cloud Engineering</span>, and I enjoy working in 
            fast-paced environments where I can learn quickly and contribute to impactful projects.  
            I also like attending tech conferences, hackathons, and connecting with people who share similar interests in the tech space. 
          </p>

          <p>
            Outside of tech, I like watching movies, going to the gym, and working on side projects.  
            You can find more of my work on{" "}
            <a
              href="https://github.com/cmell05"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              GitHub
            </a>{" "}
            or connect with me on{" "}
            <a
              href="https://www.linkedin.com/in/carmellasetiabudi/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              LinkedIn
            </a>
            .
          </p>
        </div>

        <div className="about-photo">
          <img src={carmella} alt="Carmella" />
        </div>
      </section>
    </div>
  );
};

export default About;
